import { useSelector } from 'react-redux';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../icon/icon';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { useTranslation } from 'react-i18next';
import CardProduct from '../../card/CardProduct/CardProduct';
import { Collapse } from 'antd';

const RightLiftSupportCustomDesignMenu = ({ open, onClose, onClickCard }) => {
  const { t } = useTranslation();
  const { liftSupport } = useSelector(state => state.liftSupport);

  return (
    <RightMenuDesign
      open={open}
      classNames={{ root: 'top-16', content: '!p-0 gap-0' }}
      header={
        <div className="flex items-center gap-8">
          <ButtonIconGhostMedium
            icon={<Icon.ICArrowBack />}
            onClick={onClose}
          />
          <span className="text-title-large text-nowrap">{t('Customize')}</span>
        </div>
      }
      content={
        <>
          <div className="flex p-8 justify-start items-start gap-2 self-stretch flex-wrap overflow-auto">
            {/* <>
              {liftSupport?.data?.handles?.map((md, i) => {
                const name = getValueFromString(md.name);
                const description = getValueFromString(md.description);

                return (
                  <CardProduct
                    key={i}
                    md={md}
                    title={name}
                    description1={description}
                    description2={md.size}
                    // description2={
                    //   <span className="text-label-small">
                    //     {md.price.toLocaleString('vi-VN', {
                    //       style: 'currency',
                    //       currency: 'VND',
                    //     })}
                    //   </span>
                    // }
                    moduleType={'moduleType'}
                    onClick={onClickCard}
                  />
                );
              })}
            </> */}
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['1', '2', '3']}
              onChange={() => {}}
              className="grow overflow-auto flex self-stretch"
              items={[
                {
                  key: '1',
                  label: (
                    <span className="text-title-medium">
                      {t('Single door')}
                    </span>
                  ),
                  children: (
                    <div className="grid !p-0 items-start align-content-start gap-2 grow self-stretch grid-cols-2">
                      {liftSupport?.data?.default_lifts?.['1canh']?.map(
                        (md, i) => {
                          // {listDoor.map((md, i) => {
                          const name = getValueFromString(md.name);
                          const description = getValueFromString(
                            md.description ?? ''
                          );

                          return (
                            <CardProduct
                              key={i}
                              md={md}
                              title={name}
                              description1={description}
                              description2={md.size}
                              moduleType={i}
                            />
                          );
                        }
                      )}
                    </div>
                  ),
                },
                {
                  key: '2',
                  label: (
                    <span className="text-title-medium">
                      {t('Double Door')}
                    </span>
                  ),
                  children: (
                    <div className="grid !p-0 items-start align-content-start gap-2 grow self-stretch grid-cols-2">
                      {liftSupport?.data?.default_lifts?.['2canh']?.map(
                        (md, i) => {
                          // {listDoor45.map((md, i) => {
                          const name = getValueFromString(md.name);
                          const description = getValueFromString(
                            md.description ?? ''
                          );

                          return (
                            <CardProduct
                              key={i}
                              md={md}
                              title={name}
                              description1={description}
                              description2={md.size}
                              moduleType={i}
                            />
                          );
                        }
                      )}
                    </div>
                  ),
                },
              ].map(item => ({
                ...item,
                onKeyDown: e => {
                  e.stopPropagation();
                },
              }))}
            />
          </div>
        </>
      }
    />
  );
};

export default RightLiftSupportCustomDesignMenu;
